import { createSlice } from "@reduxjs/toolkit";
import changePasswordApi from "@custom/rtk-apis/user/changePassword";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const changePasswordSlice = createSlice({
  name: "patientListSlice",
  initialState,
  reducers: {
    changePasswordRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    changePasswordSuccess: (state, action) => {
      state.status = 'SUCCESS';
      state.msg = action.payload.msg;
      state.result = action.payload.result;
      state.loading = false;
    },
    changePasswordFailure: (state, action) => {
      state.status = 'ERROR';
      state.msg = action.payload.msg;
      state.error = action.payload.error;
      state.loading = false;
    },
    resetChangePasswordStatus: (state) => {
      state.status = '';
      state.msg = '';
      state.result = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(changePasswordApi.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(changePasswordApi.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(changePasswordApi.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default changePasswordSlice.reducer;
export const { changePasswordRequest, changePasswordSuccess, changePasswordFailure, resetChangePasswordStatus } = changePasswordSlice.actions;
